import type { ContentData } from '@/lib/serverDataFetchers'

interface ApproachProps {
  content?: ContentData
}

const Approach = ({ content }: ApproachProps) => {
  return (
    <div className="relative isolate overflow-hidden py-24 sm:py-32">
      {/* Background Image */}
      <img
        alt="KES Global Advisors Approach"
        src="https://kesimages.sfo3.cdn.digitaloceanspaces.com/KES/kes_approach.webp"
        className="absolute inset-0 -z-20 h-full w-full object-cover object-center"
        loading="lazy"
      />

      {/* Overlay */}
      <div className="absolute inset-0 -z-10 bg-gray-900/70"></div>

      {/* Content */}
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
            {content?.approach_title || "Our Approach"}
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-300">
            {content?.approach_description || "We combine strategic insights with practical expertise to deliver exceptional results for our clients."}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Approach
